module.exports = __webpack_public_path__ + "static/media/grade-levels.971e6674.md";